<template>
    <div class="sidebar-sticky" id="trackers_list">
        <div class="bg-dark-nvx mx-0 pb-2">
            <div class="btn-group btn-block btn-bar-nvx">
                <input class="form-control-sm input-nvx" type="search" :placeholder="$t('search')"
                       :aria-label="$t('search')"
                       v-model="q" v-on:input="search">

                <b-dropdown :text="$t('sort')" variant="primary" class="btn-block-nvx custom-dropdown"
                             ref="dropdown" right boundary="viewport">
                    <div style="cursor: pointer;" class="dropdown-item" v-bind:class="{'active': sort.endsWith('name') }"
                         v-on:click="sort_devices('name')">{{$t('sort_by_name')}}
                    </div>
                    <div style="cursor: pointer;" class="dropdown-item" v-bind:class="{'active': sort.endsWith('last') }"
                         v-on:click="sort_devices('last')">{{$t('sort_by_last_event')}}
                    </div>
                    <div style="cursor: pointer;" class="dropdown-item" v-bind:class="{'active': sort.endsWith('stationary') }"
                         v-on:click="sort_devices('stationary')">{{$t('sort_by_stationary')}}
                    </div>
                    <div style="cursor: pointer;" class="dropdown-item" v-bind:class="{'active': sort.endsWith('battery') }"
                         v-on:click="sort_devices('battery')">{{$t('sort_by_battery')}}
                    </div>
                    <div style="cursor: pointer;" class="dropdown-item" v-bind:class="{'active': sort.endsWith('sub_end_date') }"
                         v-on:click="sort_devices('sub_end_date')">{{$t('sort_by_subscription_end_date')}}
                    </div>
                    <!-- <div style="cursor: pointer;" class="dropdown-item" v-bind:class="{'active': (sort=='tag') }"
                         v-on:click="sort_devices('tag')">{{$t('sort_by_tag')}}
                    </div> -->
                </b-dropdown>
            </div>
        </div>
        <ul class="nav flex-column">
            <li class="nav-item border-bottom" style="border-color: #333 !important;">
              <div v-if="trackers==null">Loading...</div>
              <div v-if="trackers" class="nav-link d-flex align-items-center justify-content-between flex-wrap"
                   v-on:click="select_all()"
                   v-bind:class="{'active': (selected==null) }">
                <span class="pr-1 flex-grow-1 text-nowrap">
                  {{$t('all_trackers')}} ({{trackers.length}})
                </span>
                <BadgeVue :sort="sort" v-on:revertSort="sort=$event"></BadgeVue>
              </div>

            </li>

            <li v-for="tracker in trackers" :key="tracker.serial" class="nav-item">
                <div class="nav-link" v-on:click="on_select(tracker)"
                     v-bind:class="{'active': (selected&&selected.id==tracker.id) }">

                    <img style="margin: auto; height: 24px; padding-right: 10px;" class="float-left mx-0" :src="`${icon(tracker)}`" alt="">
                    <span class="nav-link-item flex-grow-1" v-text="tracker.name"></span>
                    <small v-if="sort=='last'||sort=='revertlast'" class="float-right">
                        <span v-text="pretty_date_tracker(tracker)"></span>
                    </small>
                    <small v-else-if="sort=='stationary'||sort=='revertstationary'" class="float-right">
                        {{tracker.tracker_status.stationary|formatStationary}}
                    </small>
                     <small v-else-if="sort.endsWith('sub_end_date')" class="float-right">
                        <div v-if="tracker.tracker_status.sub_state!=='normal'"
                              v-html="subStateIcon(tracker.tracker_status.sub_state)">
                        </div>

                     </small>
                    <img v-else class="float-right"
                         :title="tracker.tracker_status.battery"
                         :src="'/images/battery/battery-'+battery(tracker)+'.svg'"
                         height="18">
                </div>
            </li>
        </ul>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.custom-dropdown .dropdown-menu {
  font-size: 0.8rem;
}

.dropdown-container-parent {
  overflow: visible;
}
.nav-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

</style>
<script>
    import {HTTP} from "../http-constants"
    import * as nvxlib from "../nvxcommon";
    import {bus} from '../event-bus'

    import "../assets/ith_style.css"
    import "../assets/scss/style.scss"
    import Vue from 'vue'
    import BadgeVue from './Badge.vue'
    import feather from 'feather-icons'

    let moment = require('moment');

    export default {
        name: 'DevicesListSideBar',
        components: {BadgeVue},
        delimiters: ['${', '}'],
        data() {
            return {
                trackers: null,
                avatar: null,
                q: '',
                sort: 'name',
                selected: null,
                // selected_tags: [],  
                tags: [],
            }
        },
        mounted() {
            if (localStorage.sort) {
                this.sort = localStorage.sort;
            }
            this.load();
            this.load_tags()

        },
        watch: {
            sort: function (val) {
                this.sort_devices(val);
                localStorage.sort = val;
            }
        },
        methods: {
          'icon': function (tracker) {
            let icon = -1;
            if (tracker.tracker_config) {
              icon = tracker.tracker_config.icon;
            }
            return nvxlib.icon_path(icon);
          },
            'load': function () {
                var self = this;
                HTTP.get('/devices/',
                    {params: {type: 'tracker', sort: this.sort, search: this.q}})
                    .then(function (re) {
                        self.trackers = re.data;
                        self.$store.state.trackers.devices = self.trackers;
                        bus.$emit('resize_trackers', self.trackers)
                        
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            'setSelected': function (tracker) {
                this.selected = tracker;
                this.$store.state.trackers.selected = tracker
                bus.$emit('tracker_panel', {action: 'map', tracker: tracker})
            },
            'selectedWithDeviceId': function (device_id) {
                var _selected = this.trackers.filter(elem => elem.id == device_id);

                if (_selected.length) {
                    this.setSelected(_selected[0]);
                    //if (trackersMapApp != null) {
                    //    trackersMapApp.select(_selected[0]);
                    //}
                }
            },
            'on_select': function (tracker) {
                this.setSelected(tracker);

                //if (trackersMapApp != null) {
                //    trackersMapApp.select(tracker);
                //} else {
                //    var _path = "/labs/devices/";
                //    if (this.selected != null) {
                //        _path += this.selected.id + "/";
                //    }
                //    location.href = _path;
                //}
            },
            'select_all': function () {
                this.setSelected(null)

                if (this.q.length) {
                    this.q = "";
                    this.load();
                }

               // if (trackersMapApp != null) {
               //     trackersMapApp.select(null);
               // } else {
               //     location.href = "/labs/devices/";
               // }
            },
            'battery': function (tracker) {
                var b = tracker.tracker_status.battery;
                if (b <= 10) return 0;
                if (b <= 20) return 1;
                if (b <= 40) return 2;
                if (b <= 60) return 3;
                if (b <= 80) return 4;

                return 5;
            },
            'sort_devices': function (sort) {
                this.$refs.dropdown.hide(true)
                this.sort = sort;
                if (this.trackers) {
                  this.trackers = Vue.filter('format' + this.sort)(this.trackers);
                }
            },
            'search': function (search) {
                if (this.q.length == 0 || this.q.length > 2) {
                    this.load()
                }
            },
            'pretty_date_tracker': function (tracker) {
                let status = tracker.tracker_status;
                if (status == null) {
                    return "";
                }
                if (status.last_event == null) {
                    return "";
                }
                var last_event = status.last_event;
                if (last_event == null) {
                    return ""
                }

                var now = moment(last_event);
                return now.fromNow()
            },
            'load_tags': function () {
                var self = this;
                HTTP.get('/devicetags/',)
                    .then(function (re) {
                        self.tags = re.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
          subStateIcon(value) {
            if (value === 'alert' || value === 'critical') {
              return feather.icons['alert-triangle'].toSvg()
            } else if (value === 'suspended' || value === 'off') {
              return feather.icons['cloud-off'].toSvg()
            }
          }
        },
        updated: function(){
          let _sort = this.sort;
        },
        created: function(){
            var self = this
            bus.$on('select_tracker', tracker => {
                var _selected = self.trackers.filter(elem => elem.id == tracker.id);
                if (_selected.length) {
                    self.setSelected(_selected[0])
                }
            })
        }
    }

</script>